'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var LOCKY_GROUP = 'data-locky-group';
var LOCKY_TRANSPARENT = 'data-locky-transparent';

var getAllInGroup = function getAllInGroup(node) {
  var group = node.getAttribute(LOCKY_GROUP);
  if (group) {
    return [].concat(_toConsumableArray(document.querySelectorAll('[' + LOCKY_GROUP + '="' + group + '"]')));
  }
  return [node];
};

var isInside = exports.isInside = function isInside(ref, target) {
  var all = getAllInGroup(ref);
  return !!all.find(function (node) {
    return node.contains(target);
  });
};

var isInsideCurrent = exports.isInsideCurrent = function isInsideCurrent(ref, target) {
  return ref.contains(target);
};

var isLastInGroup = exports.isLastInGroup = function isLastInGroup(ref) {
  var refs = getAllInGroup(ref);
  return refs[refs.length - 1] === ref;
};

var shouldIgnoreEvent = exports.shouldIgnoreEvent = function shouldIgnoreEvent(eventNode) {
  var freeNodes = [].concat(_toConsumableArray(document.querySelectorAll('[' + LOCKY_TRANSPARENT + '="true"]')));
  return freeNodes.some(function (node) {
    return node.contains(eventNode);
  });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-locky/dist/isInside.js
// module id = 965
// module chunks = 58